import {  Outlet } from "react-router-dom";
//import { useContext, useCallback } from 'react';

export default function Root(params) {
  //const { user, loggedIn } = useContext(params.context);

  return <Outlet />
};
